export enum FormField {
  Email = 'email',
}

export type FormFields = {
  [FormField.Email]: string;
};
